var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvgSessionIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#7367F0",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C16.9 12 12 16.9 12 23C12 29.1 16.9 34 23 34C29.1 34 34 29.1 34 23C34 16.9 29.1 12 23 12ZM23 32C18 32 14 28 14 23C14 18 18 14 23 14C28 14 32 18 32 23C32 28 28 32 23 32ZM26.7 26.7C27.1 26.3 27.1 25.7 26.7 25.3L24 22.6V17C24 16.4 23.6 16 23 16C22.4 16 22 16.4 22 17V23C22 23.3 22.1 23.5 22.3 23.7L25.3 26.7C25.5 26.9 25.7 27 26 27C26.3 27 26.5 26.9 26.7 26.7Z",
    fill: "#7367F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1803_14624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 22,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12C16.9 12 12 16.9 12 23C12 29.1 16.9 34 23 34C29.1 34 34 29.1 34 23C34 16.9 29.1 12 23 12ZM23 32C18 32 14 28 14 23C14 18 18 14 23 14C28 14 32 18 32 23C32 28 28 32 23 32ZM26.7 26.7C27.1 26.3 27.1 25.7 26.7 25.3L24 22.6V17C24 16.4 23.6 16 23 16C22.4 16 22 16.4 22 17V23C22 23.3 22.1 23.5 22.3 23.7L25.3 26.7C25.5 26.9 25.7 27 26 27C26.3 27 26.5 26.9 26.7 26.7Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1803_14624)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 24,
    height: 24,
    fill: "#7367F0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgSessionIcon);
export default __webpack_public_path__ + "static/media/avg-session-icon.4511f2d0b75a4279d95cdafe5b32ed16.svg";
export { ForwardRef as ReactComponent };